export const getCashierModuleStub = () => ({
    general_store: {
        init: () => Promise.resolve(),
        setIsDeposit: () => undefined,
        deposit_target: '',
        setDepositTarget: () => undefined,
        should_show_all_available_currencies: false,
        setShouldShowAllAvailableCurrencies: () => undefined,
    },
    withdraw: {
        is_10k_withdrawal_limit_reached: false,
    },
    payment_agent: {
        is_payment_agent_visible: false,
    },
    account_transfer: {
        is_mt5_transfer_in_progress: false,
    },
});
